import { Directive, ElementRef, EventEmitter, Input, Output } from '@angular/core';
import { TimeParserService } from '../../core/services/time-parser.service';

@Directive({
  selector: '[appDateTwentyFourHours]',
  host: {
    '(blur)': 'formatTime($event.target.value)',
    '(keyup)': 'validate($event.target.value)'
  }
})
export class DateTwentyFourHoursDirective {

  @Input('isTimeValid') isTimeValid: boolean;
  @Output() valueChange = new EventEmitter<string>();

  constructor(private elementRef: ElementRef, private timeParserService: TimeParserService) { }

  formatTime(value:any) {
    var tempVal = value;
    var newVal = "";

    switch (tempVal.length) {
      case 1:
        newVal = "0" + tempVal + ":00";
        break;
      case 2:
        newVal = tempVal + ":00";
        break;
      case 4:
        newVal = tempVal + "0";
        break;
      default:
        newVal = tempVal;
    }

    if (newVal != "") {
      this.isTimeValid = this.timeParserService.parseTime(newVal) == null;
    }
    this.valueChange.emit(newVal);
  }

  validate(value: any) {
    if (value != null && value != "") {
      var mask = "99:99";
      var maskLength = mask.replace(/[\D\s]/gi, '').length;
      var newVal = value.replace(/[^\d]/gi, '');
      var newVal = newVal.replace(/[\D\s]/gi, '');
      var returnValue = "";
      for (var i = 0; i < newVal.length; i++) {
        if (i >= maskLength) {
          break;
        }
        if (i == 2) {
          returnValue += (":" + newVal.charAt(i));
        }
        else {
          returnValue += (newVal.charAt(i));
        }
      }

      if (newVal.length == 4) {
        var timeObj = this.timeParserService.parseTime(returnValue);
        var isValid = returnValue != '' && timeObj != null;
        this.isTimeValid = !isValid;    
      }
      this.valueChange.emit(returnValue);
    }
  }
}